import { deleteIndexedDB, isIndexedDBAvailable, saveDataToIndexedDB } from "@/utils/indexedDB";

let ttData = null;
let ttFile = null;

export const STORE_TT_DATA = "STORE_TT_DATA";
export const STORE_TT_FILE = "STORE_TT_FILE";
export const DATA_LOADED = "DATA_LOADED";


export const storeTTData = (data) => {
	return async (dispatch) => {
		dispatch({ type: STORE_TT_DATA, payload: data });
		if (isIndexedDBAvailable()) {
			await saveDataToIndexedDB("ttDataDB", "ttData", data);
		} else {
			ttData = data;
		}
	};
};

export const storeTTFile = (file) => {
	return async (dispatch) => {
		dispatch({ type: STORE_TT_FILE, payload: file });
		if (isIndexedDBAvailable()) {
			await saveDataToIndexedDB("ttFileDB", "ttFile", file);
		} else {
			ttFile = file;
		}
	};
};

export const clearTTDataAndFile = () => {
	return async (dispatch) => {
		dispatch({ type: STORE_TT_DATA, payload: null });
		dispatch({ type: STORE_TT_FILE, payload: null });
		if (isIndexedDBAvailable()) {
			await deleteIndexedDB("ttDataDB");
			await deleteIndexedDB("ttFileDB");
		} else {
			ttData = null;
			ttFile = null;
		}
	};
};

export const dataLoaded = () => ({
	type: DATA_LOADED,
});
